import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VehicleDetailsPage from "../pages/vehicle-details/page";
import ComparePage from "../pages/compare/page";
import InventoryPage from "../pages/inventory/page";
import WishlistPage from "../pages/wishlist/page";
import SellTradePage from "../pages/sell-trade/page";
import ReviewsPage from "../pages/reviews/page";
import FinancingPage from "../pages/financing/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vehicle-details",
    element: <VehicleDetailsPage />,
  },
  {
    path: "/compare",
    element: <ComparePage />,
  },
  {
    path: "/inventory",
    element: <InventoryPage />,
  },
  {
    path: "/wishlist",
    element: <WishlistPage />,
  },
  {
    path: "/sell-trade",
    element: <SellTradePage />,
  },
  {
    path: "/reviews",
    element: <ReviewsPage />,
  },
  {
    path: "/financing",
    element: <FinancingPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    // Catch‑all route for undefined paths
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
